export const STORE_NAME = 'JiraPlatformSidebarStore';

export const PACKAGE_NAME = 'jiraPlatformSidebar';
